import { EventModel } from '@/app/models/newDelegation/eventModel'
import { matchEvent } from '@/app/common/newDelegation/eventIdentity'
import { ActivityModel } from '@/modules/drivers/types/activities'
import { withVehicleFromActivities, withVehicleOnEdit } from './eventVehicle'
import { syncTmsPairOnEdit, unlinkRemovedTmsPairs } from './eventTmsPair'

type Activities = ReadonlyArray<ActivityModel> | undefined

// Chart edits of a delegation's event list, shared by the new and the edited delegation.
// The result is neither sorted nor renumbered.
export const addTripEvent = (
  events: EventModel[],
  event: EventModel,
  activities: Activities,
): EventModel[] => {
  const added = withVehicleFromActivities(
    { ...event, temporary: false },
    activities,
  )
  return syncTmsPairOnEdit([...events, added], added, undefined, activities)
}

export const editTripEvent = (
  events: EventModel[],
  event: EventModel,
  activities: Activities,
): EventModel[] => {
  const edited = { ...event, temporary: false }
  const previous = events.find((e) => matchEvent(e, edited))
  const processed = withVehicleOnEdit(edited, previous, activities)
  const updated = previous
    ? events.map((e) => (matchEvent(e, processed) ? processed : e))
    : [...events, processed]
  return syncTmsPairOnEdit(updated, processed, previous, activities)
}

export const removeTripEvents = (
  events: EventModel[],
  removed: ReadonlyArray<EventModel>,
): EventModel[] =>
  unlinkRemovedTmsPairs(
    events.filter((e) => !removed.some((r) => matchEvent(e, r))),
    removed,
  )

export const removeTripEventsAt = <T extends EventModel>(
  events: T[],
  indices: ReadonlyArray<number>,
): T[] =>
  unlinkRemovedTmsPairs(
    events.filter((_, index) => !indices.includes(index)),
    events.filter((_, index) => indices.includes(index)),
  ) as T[]
